import { configureStore } from "@reduxjs/toolkit";

import { extendedApiSlice } from "./slices/api/generationSlice";
import { applicationSlice, verificationStatusSlice } from "./slices/client";

export const store = configureStore({
  reducer: {
    [extendedApiSlice.reducerPath]: extendedApiSlice.reducer,
    application: applicationSlice.reducer,
    verificationStatus: verificationStatusSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(extendedApiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
